<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" v-if="loading">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-if="!loading">
              <!-- Start Title -->
              <div class="d-flex bd-highlight mb-3">
                <div class="me-auto p-2 bd-highlight">
                  <h4 class="card-title">{{ detail.opportunity_name }}</h4>
                  <!-- Card Title -->
                  <h6>
                    <span
                      v-for="(tag, tagI) in detail.tags"
                      :key="tagI"
                      class="badge me-2"
                      :style="'background-color:' + tag.color"
                    >
                      {{ tag.name }}
                    </span>
                  </h6>
                </div>

                <div class="p-2 bd-highlight">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect waves-light"
                    @click="
                      $router.push(
                        '/mpg/opportunities/' + detail.opportunity_id + '/edit'
                      )
                    "
                  >
                    Edit
                  </button>
                </div>

                <div class="p-2 bd-highlight">
                  <b-button
                    class="btn btn-danger waves-effect waves-light"
                    v-b-modal.delete_opportunity_modal
                  >
                    Delete</b-button
                  >
                </div>
              </div>
              <!-- End Title -->

              <!-- Start Modal -->
              <b-modal
                id="delete_opportunity_modal"
                tabindex="-1"
                aria-labelledby="delete_modal_label"
                aria-hidden="true"
                hide-footer
              >
                <template #modal-header>
                  <h6 class="text-center">
                    DELETE {{ detail.opportunity_name }} -
                    {{ detail.opportunity_id }}
                  </h6>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    :disabled="loadingAction"
                    @click="$bvModal.hide('delete_opportunity_modal')"
                  ></button>
                </template>

                <div class="modal-body">
                  <h3 class="text-center">Are you sure?</h3>
                  <h6 class="text-center">You won't be able to revert this.</h6>
                  <div class="d-grid gap-2 d-md-block text-center">
                    <form method="POST">
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                      />
                      <button
                        class="btn btn-danger waves-effect waves-light"
                        type="submit"
                        name="delete_opportunity"
                        value="11"
                        @click="deleteOpportunity(detail.opportunity_id)"
                        :disabled="loadingAction"
                      >
                        Delete
                      </button>
                      <button
                        class="btn btn-light waves-effect waves-light"
                        type="button"
                        :disabled="loadingAction"
                        data-bs-dismiss="modal"
                        @click="$bvModal.hide('delete_opportunity_modal')"
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              </b-modal>
              <!-- End Modal -->

              <b-tabs
                v-model="tabIndex"
                class="nav-tabs-custom nav-justified"
                active-tab-class="p-3"
                @activate-tab="onChangeTab"
              >
                <b-tab>
                  <template #title>
                    <span class="d-block d-sm-none"
                      ><i class="fas fa-details"></i
                    ></span>
                    <span class="d-none d-sm-block">Opportunity Details</span>
                  </template>
                  <b-card-text>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="card h-100">
                          <div class="card-body">
                            <h4 class="card-title">Details</h4>
                            <!-- Card Title -->
                            <p></p>

                            <!-- Start Table -->
                            <div class="table-responsive">
                              <table
                                class="
                                  table
                                  align-middle
                                  table-striped table-nowrap
                                  mb-0
                                "
                              >
                                <tbody>
                                  <tr>
                                    <td>Annual Volume</td>

                                    <td>
                                      {{ detail.sales_annual_volume_manual }}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Sales Person Represented</td>

                                    <td>{{ detail.sales_represented }}</td>
                                  </tr>

                                  <tr>
                                    <td>Broker Name</td>

                                    <td>{{ detail.broker_name }}</td>
                                  </tr>

                                  <tr>
                                    <td>Broker Fee</td>

                                    <td>{{ detail.broker_fee }}</td>
                                  </tr>

                                  <tr>
                                    <td>Credit Request</td>

                                    <td>
                                      {{
                                        detail.credit_request
                                          ? detail.credit_request.toUpperCase()
                                          : ""
                                      }}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Pricing Due Date</td>

                                    <td>
                                      {{
                                        detail.pricing_due_date
                                          ? moment(
                                              detail.pricing_due_date
                                            ).format("MMMM DD, YYYY, HH:mm A")
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <!-- End Table -->
                          </div>
                          <!-- End Card Body -->
                        </div>
                        <!-- End Card -->
                      </div>
                      <!-- End Col -->

                      <div class="col-lg-6">
                        <div class="card h-100">
                          <div class="card-body">
                            <h4 class="card-title">Metadata</h4>
                            <!-- Card Title -->
                            <p></p>

                            <!-- Start Table -->
                            <div class="table-responsive">
                              <table
                                class="
                                  table
                                  align-middle
                                  table-striped table-nowrap
                                  mb-0
                                "
                              >
                                <tbody>
                                  <tr>
                                    <td>Version</td>
                                    <td>{{ detail.version }}</td>
                                  </tr>

                                  <tr>
                                    <td>Created by</td>
                                    <td>{{ detail.created_by.username }}</td>
                                  </tr>

                                  <tr>
                                    <td>Created at</td>
                                    <td>
                                      {{
                                        moment(detail.created_at).format(
                                          "MMMM DD, YYYY, HH:mm A"
                                        )
                                      }}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Modified by</td>
                                    <td>{{ detail.modified_by.username }}</td>
                                  </tr>

                                  <tr>
                                    <td>Modified at</td>
                                    <td>
                                      {{
                                        moment(detail.modified_at).format(
                                          "MMMM DD, YYYY, HH:mm A"
                                        )
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <!-- End Table -->
                          </div>
                          <!-- End Card Body -->
                        </div>
                        <!-- End Card -->
                      </div>
                      <!-- End Col -->
                    </div>

                    <div class="row mt-4" v-if="!loading">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title">Notes</h4>
                            {{ detail.notes }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4" v-if="!loading">
                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body">
                            <!-- Start Title -->
                            <div class="row mb-4">
                              <div class="d-flex justify-content-between">
                                <h4 class="card-title">Bids</h4>
                                <router-link
                                  class="
                                    btn btn-primary
                                    waves-effect waves-light
                                  "
                                  :to="
                                    '/mpg/opportunities/' +
                                    $route.params.id +
                                    '/bid/new'
                                  "
                                >
                                  Add Bid
                                </router-link>
                              </div>
                            </div>
                            <!-- End Title -->
                            <div
                              class="table-responsive"
                              v-if="detail.bids.length > 0"
                            >
                              <table
                                class="
                                  table table-hover table-borderless
                                  align-middle
                                  table-centered table-nowrap
                                  mb-0
                                "
                              >
                                <thead class="table-light">
                                  <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Legal Entity</th>
                                    <th>Supplier</th>
                                    <th>Utility State</th>
                                    <th>Annual Volume</th>
                                    <th>Pricing Type</th>
                                    <th>Terms</th>
                                    <th>Start Date</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr
                                    v-for="(bid, index) in detail.bids"
                                    :key="index"
                                  >
                                    <td class="text-center">
                                      <router-link
                                        :to="
                                          '/mpg/opportunities/' +
                                          detail.opportunity_id +
                                          '/bid/' +
                                          bid.bid_id +
                                          '/edit-from-bid'
                                        "
                                        class="
                                          btn btn-link
                                          text-primary
                                          mb-0
                                          p-0
                                        "
                                      >
                                        <i class="fas fa-edit text-xs"></i>
                                      </router-link>
                                    </td>
                                    <td>
                                      <router-link
                                        :to="
                                          '/mpg/opportunities/' +
                                          $route.params.id +
                                          '/bid/' +
                                          bid.bid_id
                                        "
                                        >{{ bid.name }}</router-link
                                      >
                                    </td>
                                    <td>{{ bid.legal_entity.name }}</td>
                                    <td class="text-capitalize">
                                      {{ bid.supplier }}
                                    </td>

                                    <td>{{ bid.utility_state.name }}</td>

                                    <td>{{ bid.annual_volume }}</td>

                                    <td>
                                      <span
                                        v-for="(
                                          pricing, prixingIndex
                                        ) in bid.pricing_type"
                                        :key="prixingIndex"
                                        class="badge bg-success me-2"
                                        >{{ pricing }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        v-for="(term, termIndex) in bid.terms"
                                        :key="termIndex"
                                        class="badge text-dark bg-warning me-2"
                                        >{{ term }}</span
                                      >
                                    </td>

                                    <td>
                                      {{
                                        bid.start_date
                                          ? moment(bid.start_date).format(
                                              "MM/DD/YYYY"
                                            )
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <p></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class="d-block d-sm-none"
                      ><i class="fas fa-details"></i
                    ></span>
                    <span class="d-none d-sm-block">Organizations</span>
                  </template>
                  <b-card-text>
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-sm-12 col-md-11">
                            <div
                              id="datatable_filter"
                              class="dataTables_filter h-100"
                            >
                              <label class="h-100"
                                >Search:
                                <input
                                  type="text"
                                  class="form-control form-control-sm h-100"
                                  placeholder=""
                                  aria-controls="datatable"
                                  v-model.trim="searchOrg"
                              /></label>
                            </div>
                          </div>

                          <div class="col-sm-12 col-md-1">
                            <button
                              type="button"
                              class="
                                btn btn-success
                                waves-effect waves-light
                                w-100
                              "
                              @click="
                                $router.push({
                                  path:
                                    '/mpg/organizations/experian/search?opportunity=' +
                                    detail.opportunity_id,
                                })
                              "
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 mt-4" v-if="detail.organizations">
                        <div class="card">
                          <div class="card-header pb-0 px-3">
                            <h6 class="mb-0">List All Organizations</h6>
                          </div>
                          <div class="card-body pt-4 p-3">
                            <div class="row">
                              <div
                                class="col-12 col-md-12"
                                v-if="
                                  detail.organizations &&
                                  detail.organizations.length === 0
                                "
                              >
                                <div
                                  class="
                                    list-group-item
                                    border-0
                                    p-4
                                    mb-2
                                    bg-gray-100
                                    border-radius-lg
                                    text-center
                                  "
                                >
                                  There is no data.
                                </div>
                              </div>
                              <template
                                v-if="
                                  detail.organizations &&
                                  detail.organizations.length > 0
                                "
                              >
                                <div class="accordion" role="tablist">
                                  <b-card
                                    no-body
                                    class="mb-1"
                                    v-for="(item, key) in detail.organizations"
                                    :key="key"
                                  >
                                    <b-card-header
                                      header-tag="header"
                                      class="pb-1"
                                      role="tab"
                                    >
                                      <div
                                        v-b-toggle="
                                          'accordion-' + item.organization_id
                                        "
                                        class="
                                          bg-default
                                          w-100
                                          not-collapsed
                                          text-white
                                        "
                                        style="
                                          overflow-anchor: none;
                                          border-radius: 4px 4px 4px 0px;
                                          justify-content: space-between;
                                          display: flex;
                                          align-items: center;
                                          padding-left: 15px;
                                        "
                                      >
                                        {{ item.name }}

                                        <button
                                          class="
                                            btn btn-success
                                            waves-effect waves-light
                                          "
                                        >
                                          Request Credit Setup
                                        </button>
                                      </div>
                                    </b-card-header>
                                    <b-collapse
                                      :id="'accordion-' + item.organization_id"
                                      visible
                                      accordion="my-accordion"
                                      role="tabpanel"
                                    >
                                      <b-card-body>
                                        <div class="row">
                                          <div class="col-12 col-md-4">
                                            <div>
                                              <b>Organization Legal Address</b>
                                            </div>
                                            <p>
                                              {{
                                                item.addresses &&
                                                item.addresses[0] &&
                                                item.addresses[0].address_street
                                              }}
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div><b>Tax ID</b></div>
                                            <input
                                              type="text"
                                              class="text-style-inline"
                                              v-model="item.tax_id"
                                              @blur="onUpdateValueOrg(item, 'tax_id')"
                                            />
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div><b>Bin</b></div>
                                            <input
                                              type="text"
                                              class="text-style-inline"
                                              v-model="item.bin_number"
                                              @blur="onUpdateValueOrg(item, 'bin_number')"
                                            />
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div><b>ZoomInfo ID</b></div>
                                            <input
                                              type="text"
                                              class="text-style-inline"
                                              v-model="item.zoominfo_id"
                                              @blur="onUpdateValueOrg(item, 'zoominfo_id')"
                                            />
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div><b>DUNS Number</b></div>
                                            <input
                                              type="text"
                                              class="text-style-inline"
                                              v-model="item.duns_number"
                                              @blur="onUpdateValueOrg(item, 'duns_number')"
                                            />
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-12">
                                            <div
                                              class="
                                                list-group-item
                                                border-0
                                                p-4
                                                mb-2
                                                bg-gray-100
                                                border-radius-lg
                                                text-center
                                              "
                                            >
                                              Credit Setups (Not Requested)
                                            </div>
                                          </div>
                                        </div>
                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>

                <b-tab>
                  <template #title>
                    <span class="d-block d-sm-none"
                      ><i class="fas fa-files"></i
                    ></span>
                    <span class="badge rounded-pill bg-success float-end">{{
                      files.length
                    }}</span>
                    <span class="d-none d-sm-block">Files</span>
                  </template>
                  <b-card-text>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="drag-area">
                          <div>
                            <div
                              :class="[
                                'dropZone',
                                dragging ? 'dropZone-over' : '',
                              ]"
                              @dragenter="dragging = true"
                              @dragleave="dragging = false"
                            >
                              <div class="dropZone-info" @drag="onChange">
                                <span
                                  style="
                                    font-size: 21pt;
                                    margin-bottom: 15px;
                                    color: #bebebe;
                                  "
                                  class="fas fa-cloud-upload-alt dropZone-title"
                                ></span>
                                <span class="dropZone-title"
                                  >Drag and drop files here</span
                                >
                                <span> Or </span>
                                <button
                                  type="button"
                                  class="
                                    btn btn-primary btn-sm btn-task
                                    mb-3
                                    mt-3
                                    removeFile
                                  "
                                  @click="fileInput.click()"
                                >
                                  Browse files
                                </button>
                                <div class="dropZone-upload-limit-info">
                                  <div>extension support: *</div>
                                  <div>maximum file size: 5 MB</div>
                                </div>
                              </div>
                              <input
                                refs="fileInput"
                                type="file"
                                @change="onChange"
                                multiple
                              />
                            </div>
                          </div>
                        </div>

                        <template v-if="fileBeforeUpload">
                          <p></p>
                          <div
                            v-for="(fileData, index) in fileBeforeUpload"
                            :key="index"
                            class="file-list-item"
                          >
                            <a :href="fileData.file" target="_blank">
                              {{ fileData.name }}
                            </a>
                            <button
                              class="
                                btn btn-link
                                text-danger text-gradient
                                px-3
                                mb-0
                              "
                              :disabled="loadingAction"
                              type="button"
                              @click="deleteFileBeforeUpload(fileData)"
                            >
                              <i
                                class="far fa-trash-alt me-2"
                                aria-hidden="true"
                              ></i
                              >Delete
                            </button>
                          </div>
                        </template>
                      </div>
                    </div>

                    <template v-if="files">
                      <div
                        v-for="(fileData, index) in files"
                        :key="index"
                        class="file-list-item"
                      >
                        <a :href="fileData.file" target="_blank">
                          {{ fileData.filename }}
                        </a>

                        <button
                          class="
                            btn btn-link
                            text-danger text-gradient
                            px-3
                            mb-0
                          "
                          :disabled="loadingAction"
                          type="button"
                          @click="deleteFile(fileData)"
                        >
                          <i
                            class="far fa-trash-alt me-2"
                            aria-hidden="true"
                          ></i
                          >Delete
                        </button>
                      </div>
                    </template>

                    <p></p>
                    <div class="row">
                      <div class="col-12">
                        <button
                          :disabled="
                            !fileBeforeUpload ||
                            fileBeforeUpload.length === 0 ||
                            loadingAction
                          "
                          type="button"
                          class="btn btn-primary waves-effect waves-light"
                          @click="onUploadFileToOpp()"
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                    <div v-if="files.length === 0" class="text-center">
                      There are no file(s)
                    </div>
                  </b-card-text>
                </b-tab>
              </b-tabs>

              <!-- End Row -->
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { opportunityService } from '../services/opportunities.service'
import { bidsService } from '../services/bids.service'
import { utilService } from '../services/util.service'
import { authenticationService } from '../services/authentication.service'

import moment from 'moment'
import { debounce } from '../helpers'

export default {
  name: 'OpportunitiesDetail',
  components: {},
  data () {
    return {
      detail: null,
      loading: true,
      tabIndex: 0,
      loadingAction: false,
      files: [],
      fileBeforeUpload: [],
      dragging: false,
      searchOrg: ''
    }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      this.$router.push('/opportunities')
    }

    if (this.$route.params.type === 'details') {
      this.tabIndex = 0
    } else {
      this.tabIndex = 1
    }
    utilService.getTag().then((tags) => {
      opportunityService
        .getFileFile('opportunity-' + this.$route.params.id)
        .then((files) => {
          this.files = files.results
        })
      opportunityService.getDataById(this.$route.params.id).then((rs) => {
        this.detail = rs
        this.loading = false
      })
    })
  },
  watch: {
    searchOrg: debounce(function (newVal) {
      console.log(newVal)
    }, 500)
  },
  methods: {
    moment,
    onUpdateValueOrg (item, field) {
      organizationsService
        .updateWithPath({
          [field]: item[field]
        }, item.organization_id)
        .then((rs) => {
          // this.$bvToast.toast('Update successfully.', {
          //   title: `Update`,
          //   variant: 'primary',
          //   solid: true
          // })
        })
        .catch(() => {
          this.$bvToast.toast('Cannot Update Organization.', {
            title: `Update`,
            variant: 'danger',
            solid: true
          })
        })
    },
    deleteOpportunity (id) {
      this.loadingAction = true
      opportunityService.deleteDataById(id).then((rs) => {
        this.loadingAction = false
        this.$router.push('/mpg/opportunities')
      })
    },
    deleteBid (id) {
      bidsService.deleteDataById(id).then((rs) => {
        this.detail.bids = this.detail.bids.filter((e) => e.bid_id !== id)
        this.$bvModal.hide('delete_bid_modal' + id)
      })
    },
    deleteFile (file) {
      this.loadingAction = true
      opportunityService
        .deleteFile(file.file_id)
        .then((rs) => {
          this.loadingAction = false
          this.$bvToast.toast('Delete successfully.', {
            title: `Update`,
            variant: 'primary',
            solid: true
          })
          this.files = this.files.filter((e) => e.file_id !== file.file_id)
          this.loadingAction = false
        })
        .catch(() => {
          this.$bvToast.toast('Cannot delete this file.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
        })
    },

    onChange (e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files)
    },

    createFile (files) {
      // if (!file.type.match('text.*')) {
      //   alert('please select txt file');
      //   this.dragging = false;
      //   return;
      // }

      const inValidFile = []

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5000000) {
          inValidFile.push(files[i])
        }
      }

      if (inValidFile.length > 0) {
        this.$bvToast.toast('Error.', {
          title: `Please check file size no over 5 MB.`,
          variant: 'danger',
          solid: true
        })
        this.dragging = false
        return
      }

      this.fileBeforeUpload = [...this.fileBeforeUpload, ...files]
      this.dragging = false
    },

    deleteFileBeforeUpload (fileData) {
      this.fileBeforeUpload = this.fileBeforeUpload.filter(
        (e) => e.name !== fileData.name
      )
    },

    onUploadFileToOpp () {
      if (this.fileBeforeUpload.length > 0) {
        const type = authenticationService.currentContentTypeValue
        const contentType = type.find((e) => e.model === 'file').id
        this.loadingAction = true
        const promise = []
        for (let i = 0; i < this.fileBeforeUpload.length; i++) {
          let formData = new FormData()
          formData.append('file', this.fileBeforeUpload[i])
          formData.append('filename', this.fileBeforeUpload[i].name)
          formData.append('object_id', 'opportunity-' + this.$route.params.id)
          formData.append('content_type', contentType)
          promise.push(
            opportunityService.uploadFile(formData).then(
              (rs) => {
                return rs
              },
              (error) => {
                this.$bvToast.toast('Error.', {
                  title: `Error. Cannot Upload File ${error}`,
                  variant: 'danger',
                  solid: true
                })
              }
            )
          )
        }
        Promise.all(promise).then((values) => {
          this.$nextTick(() => {
            setTimeout(() => {
              opportunityService
                .getFileFile('opportunity-' + this.$route.params.id)
                .then((files) => {
                  this.files = files.results
                  this.loadingAction = false
                  this.fileBeforeUpload = []
                })
            }, 100)
          })
        })
      } else {
        this.loadingAction = false
      }
    },

    onChangeTab (tab) {
      switch (tab) {
        case 0:
          this.$router.push(
            `/mpg/opportunities/${this.$route.params.id}/details`
          )
          break
        case 1:
          this.$router.push(
            `/mpg/opportunities/${this.$route.params.id}/files`
          )
          break
        default:
          break
      }
    },
    onSubmit () {}
  }
}
</script>

<style scoped>
.picker-input {
  position: relative;
  z-index: 98;
  width: 50px;
}
.picker-box {
  position: absolute;
  top: 47px;
  left: 1px;
  z-index: 99;
}
.picker-fade {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 97;
  left: 0;
  top: 0;
}

.form-control-color {
  padding: 0.47rem !important;
  height: 39px !important;
}

.text-style-inline {
  background: #f5f5f5;
  border: none;
  padding: 8px;
  margin-bottom: 20px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/OpportunitiesDetail.vue